import { Link } from "gatsby";
import React from "react";

export const GettingStartedVector: React.FunctionComponent = () => {
  return (
    <svg
      id="Layer_1"
      className="getting-started-svg"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 446.84 550.12"
    >
      <defs>
        <style>
          {`
        .cls-1 {
          fill: #5e5e5e;
        }
  
        .cls-2 {
          fill: #2b2b2b;
        }
  
        .cls-3 {
          fill: #282828;
        }
  
        .cls-4 {
          fill: url(#linear-gradient);
        }
  
        .cls-5 {
          fill: #191919;
        }
  
        .cls-6 {
          font-size: 16px;
          font-family: Montserrat-Medium, Montserrat;
          font-weight: 500;
        }
  
        .cls-19, .cls-7 {
          fill: #fff;
        }
  
        .cls-7 {
          opacity: 0;
        }
  
        .cls-8 {
          fill: #4c4c4c;
        }
  
        .cls-9 {
          fill: url(#linear-gradient-2);
        }
  
        .cls-10 {
          fill: url(#linear-gradient-3);
        }
  
        .cls-11 {
          fill: #4e4f4e;
        }
  
        .cls-12 {
          fill: url(#linear-gradient-4);
        }
  
        .cls-13 {
          fill: none;
          stroke: #424242;
          stroke-miterlimit: 10;
          stroke-width: 0.25px;
        }
  
        .cls-14 {
          fill: url(#linear-gradient-5);
        }
  
        .cls-15 {
          fill: url(#linear-gradient-6);
        }
  
        .cls-16 {
          fill: url(#linear-gradient-7);
        }
  
        .cls-17 {
          fill: url(#linear-gradient-8);
        }
  
        .cls-18 {
          fill: #212121;
        }
  
        .cls-20 {
          fill: #303030;
        }
  
        .cls-21 {
          fill: #f0f2eb;
        }
  
        .cls-22 {
          fill: url(#linear-gradient-9);
        }
  
        .cls-23 {
          fill: url(#radial-gradient);
        }
  
        .cls-24 {
          fill: url(#radial-gradient-2);
        }
  
        .cls-25 {
          fill: url(#radial-gradient-3);
        }
  
        .cls-26 {
          fill: url(#linear-gradient-10);
        }
  
        .cls-27 {
          fill: url(#linear-gradient-11);
        }
  
        .cls-28 {
          fill: #828282;
        }
  
        .cls-29 {
          fill: url(#linear-gradient-12);
        }
        `}
        </style>
        <linearGradient id="linear-gradient" x1="323.3" y1="350.21" x2="375.39" y2="350.21" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ff6296" />
          <stop offset="0.03" stopColor="#ff5d8d" />
          <stop offset="0.13" stopColor="#ff4b6f" />
          <stop offset="0.24" stopColor="#ff3d56" />
          <stop offset="0.36" stopColor="#ff3242" />
          <stop offset="0.5" stopColor="#ff2a34" />
          <stop offset="0.68" stopColor="#ff252c" />
          <stop offset="1" stopColor="#ff242a" />
        </linearGradient>
        <linearGradient id="linear-gradient-2" x1="99.25" y1="77.74" x2="99.25" y2="103.96" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#fffe95" />
          <stop offset="1" stopColor="#ffe101" />
        </linearGradient>
        <linearGradient id="linear-gradient-3" x1="87.27" y1="90.66" x2="111.29" y2="90.66" xlinkHref="#linear-gradient-2" />
        <linearGradient id="linear-gradient-4" x1="97.6" y1="99.62" x2="102.75" y2="99.62" xlinkHref="#linear-gradient-2" />
        <linearGradient id="linear-gradient-5" x1="94.42" y1="253.28" x2="101.32" y2="246.38" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#636479" />
          <stop offset="0.01" stopColor="#61667c" />
          <stop offset="0.14" stopColor="#537d95" />
          <stop offset="0.28" stopColor="#488ea8" />
          <stop offset="0.44" stopColor="#409bb6" />
          <stop offset="0.64" stopColor="#3ba2be" />
          <stop offset="1" stopColor="#3aa4c0" />
        </linearGradient>
        <linearGradient id="linear-gradient-6" x1="102.59" y1="245.37" x2="106.58" y2="241.38" xlinkHref="#linear-gradient-5" />
        <linearGradient id="linear-gradient-7" x1="85" y1="333.84" x2="102.79" y2="303.03" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#675d72" />
          <stop offset="0.19" stopColor="#61677d" />
          <stop offset="0.53" stopColor="#508199" />
          <stop offset="0.96" stopColor="#36abc8" />
          <stop offset="1" stopColor="#33afcc" />
        </linearGradient>
        <linearGradient id="linear-gradient-8" x1="280.28" y1="148.36" x2="286.85" y2="175.93" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#fa40ff" />
          <stop offset="0.55" stopColor="#1400de" />
          <stop offset="0.92" stopColor="#beffb9" />
        </linearGradient>
        <linearGradient id="linear-gradient-9" x1="155.4" y1="531.49" x2="190.06" y2="496.83" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#64ff4f" />
          <stop offset="0.08" stopColor="#6cff6e" />
          <stop offset="0.17" stopColor="#74ff8c" />
          <stop offset="0.28" stopColor="#7affa5" />
          <stop offset="0.39" stopColor="#7fffb9" />
          <stop offset="0.53" stopColor="#82ffc7" />
          <stop offset="0.7" stopColor="#84ffcf" />
          <stop offset="1" stopColor="#85ffd1" />
        </linearGradient>
        <radialGradient id="radial-gradient" cx="193.75" cy="542.58" r="14.25" gradientUnits="userSpaceOnUse">
          <stop offset="0.02" stopColor="#636479" />
          <stop offset="0.24" stopColor="#60687d" />
          <stop offset="0.48" stopColor="#59748b" />
          <stop offset="0.74" stopColor="#4c88a1" />
          <stop offset="0.99" stopColor="#3ba3bf" />
          <stop offset="1" stopColor="#3aa4c0" />
        </radialGradient>
        <radialGradient id="radial-gradient-2" cx="186.97" cy="526.17" r="24.82" xlinkHref="#linear-gradient-5" />
        <radialGradient id="radial-gradient-3" cx="163.44" cy="549.73" r="9.04" xlinkHref="#linear-gradient-5" />
        <linearGradient id="linear-gradient-10" x1="160.65" y1="524.83" x2="177.75" y2="507.73" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ffa3b4" />
          <stop offset="0.01" stopColor="#ffa4b3" />
          <stop offset="0.14" stopColor="#ffbc9a" />
          <stop offset="0.28" stopColor="#ffcf86" />
          <stop offset="0.45" stopColor="#ffdc78" />
          <stop offset="0.65" stopColor="#ffe46f" />
          <stop offset="1" stopColor="#ffe66d" />
        </linearGradient>
        <linearGradient id="linear-gradient-11" x1="166.82" y1="518.96" x2="172.52" y2="513.25" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#636479" />
          <stop offset="0.04" stopColor="#776674" />
          <stop offset="0.13" stopColor="#9b6a6a" />
          <stop offset="0.22" stopColor="#ba6e62" />
          <stop offset="0.32" stopColor="#d3715b" />
          <stop offset="0.43" stopColor="#e77355" />
          <stop offset="0.55" stopColor="#f57552" />
          <stop offset="0.71" stopColor="#fd7650" />
          <stop offset="1" stopColor="#ff764f" />
        </linearGradient>
        <linearGradient id="linear-gradient-12" x1="214.75" y1="515.01" x2="223.22" y2="515.01" xlinkHref="#linear-gradient-11" />
      </defs>
      <g>
        <path
          className="cls-1"
          d="M97.84,138.17a42.78,42.78,0,0,0,1.67,5.74c.69,1.87,1.46,3.71,2.33,5.51a.23.23,0,0,1-.11.3.23.23,0,0,1-.3-.11h0c-.84-1.83-1.58-3.7-2.23-5.59a43.3,43.3,0,0,1-1.56-5.81.1.1,0,0,1,.2,0Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-1"
          d="M108,159.6a62,62,0,0,0,8,8.8.47.47,0,0,1,0,.67.47.47,0,0,1-.67,0h0a62.86,62.86,0,0,1-7.94-9.08.34.34,0,0,1,.08-.49A.35.35,0,0,1,108,159.6Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-1"
          d="M125.58,175.51a69.26,69.26,0,0,0,10.63,5.29.68.68,0,0,1,.38.87.67.67,0,0,1-.87.38h0A69.5,69.5,0,0,1,125,176.49a.58.58,0,0,1,.61-1Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-1"
          d="M147.56,184.33a92.88,92.88,0,0,0,11.73,1.95.89.89,0,0,1,.78,1,.88.88,0,0,1-1,.78h0a99.92,99.92,0,0,1-11.89-2.21.77.77,0,0,1,.36-1.49Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-1"
          d="M171.17,186.91c4,0,7.94-.15,11.91-.4a1,1,0,0,1,.14,2.05c-4,.32-8.05.4-12.08.33a1,1,0,0,1,0-2Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-1"
          d="M195,185.35l11.81-1.84h0a.73.73,0,0,1,.84.61.75.75,0,0,1-.59.84l-11.84,2.21a.92.92,0,0,1-1.08-.73.94.94,0,0,1,.74-1.08H195Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-1"
          d="M218.5,181.16c2.82-.65,5.64-1.32,8.48-1.94a.09.09,0,0,1,.12.07.11.11,0,0,1-.06.12c-2.77.89-5.55,1.72-8.33,2.58a.42.42,0,0,1-.53-.28.41.41,0,0,1,.28-.53h0Z"
          transform="translate(-1.62 -12.46)"
        />
      </g>
      <g>
        <path
          className="cls-2"
          d="M337.64,156.84a107.34,107.34,0,0,1,11.59-3.19.3.3,0,0,1,.37.24.32.32,0,0,1-.24.38h0c-3.91.75-7.82,1.64-11.65,2.76a.12.12,0,0,1-.13-.07A.11.11,0,0,1,337.64,156.84Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M361.09,151.62a100.77,100.77,0,0,1,12-.69.62.62,0,0,1,0,1.24h0a98.88,98.88,0,0,0-11.92.43.49.49,0,0,1-.54-.44A.5.5,0,0,1,361.09,151.62Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M385.18,152a48.18,48.18,0,0,1,11.62,3.61.79.79,0,0,1-.67,1.44h0a47.49,47.49,0,0,0-11.21-3.6.74.74,0,0,1,.27-1.45Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M406.88,162.5a34.39,34.39,0,0,1,7.05,10,.87.87,0,0,1-.42,1.18.9.9,0,0,1-1.19-.42h0a33.14,33.14,0,0,0-6.62-9.56.84.84,0,0,1,1.18-1.2Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M417.45,184.19l.38,2.71v-.1a14.3,14.3,0,0,1,.26,4.92,17.3,17.3,0,0,1-1.28,4.71.82.82,0,0,1-1.52-.64,13.78,13.78,0,0,0,.87-8.59v-.1l-.39-2.62v0a.87.87,0,0,1,1.72-.25Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M409.61,206.31a74.42,74.42,0,0,1-9.37,7.66.59.59,0,0,1-.68-1,73.21,73.21,0,0,0,9-7.7.71.71,0,1,1,1,1Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M390,220.36c-3.56,1.86-7.09,3.75-10.63,5.64a.37.37,0,1,1-.35-.65h0c3.51-1.91,7-3.82,10.5-5.76l0,0a.46.46,0,0,1,.62.18.45.45,0,0,1-.17.62Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M368.53,231.09c-3.69,1.54-7.37,3.12-11,4.7a.32.32,0,0,1-.25-.59h0c3.68-1.55,7.37-3.09,11-4.68h0a.32.32,0,0,1,.26.59Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M346.3,240.17,335,244.29a.45.45,0,0,1-.3-.84h0l11.32-3.95h0a.36.36,0,0,1,.24.68Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M323.66,248.17l-11.44,3.66a.69.69,0,0,1-.85-.44.67.67,0,0,1,.44-.84h0l11.49-3.42h0a.56.56,0,0,1,.33,1.06Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M300.71,255.26l-11.58,3.21a.86.86,0,0,1-.46-1.65h0l11.59-3.05h0a.78.78,0,0,1,.41,1.5Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M277.5,261.48l-11.68,2.81a1,1,0,0,1-.45-1.88h0l11.67-2.72h0a.91.91,0,0,1,1.1.68A.92.92,0,0,1,277.5,261.48Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M254.1,266.93l-11.76,2.47a1.06,1.06,0,0,1-.43-2.07h0L253.68,265h0a1,1,0,1,1,.41,2Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M230.54,271.65l-11.83,2.07a1,1,0,0,1-1.19-.83,1,1,0,0,1,.83-1.2h0l11.8-2.1h0a1,1,0,0,1,1.21.84,1,1,0,0,1-.84,1.22Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M206.85,275.63,195,277.35a1,1,0,0,1-.28-1.94h0l11.86-1.78h0a1,1,0,0,1,.3,2Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M183,278.84l-11.94,1.31a.82.82,0,0,1-.19-1.62h0l11.9-1.46h0a.9.9,0,1,1,.22,1.79Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M159.13,281.26l-12,.86a.59.59,0,0,1-.1-1.18h0L159,279.81h0a.72.72,0,0,1,.79.65.74.74,0,0,1-.66.8Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M135.15,282.77l-12,.36a.28.28,0,0,1-.28-.27.27.27,0,0,1,.26-.28h0l12-.74h0a.47.47,0,1,1,0,.93Z"
          transform="translate(-1.62 -12.46)"
        />
      </g>
      <g>
        <path
          className="cls-2"
          d="M62.06,291.29c-2,.35-3.91.8-5.85,1.28s-3.86,1-5.77,1.58a.33.33,0,0,1-.41-.22.33.33,0,0,1,.22-.41h0A98.45,98.45,0,0,1,62,291.09a.1.1,0,1,1,0,.2Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M39.18,298.16a92.17,92.17,0,0,0-10.7,5.25.65.65,0,0,1-.87-.23.64.64,0,0,1,.24-.87h0a91.11,91.11,0,0,1,10.94-5.08.51.51,0,0,1,.66.29A.5.5,0,0,1,39.18,298.16Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M18.75,310.19a48.21,48.21,0,0,0-8.08,8.57.79.79,0,0,1-1.12.19.81.81,0,0,1-.18-1.13h0A49.67,49.67,0,0,1,17.79,309a.76.76,0,0,1,1.06.11A.75.75,0,0,1,18.75,310.19Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M5.31,329.16a39.22,39.22,0,0,0-1.9,11.53.9.9,0,0,1-.92.87.89.89,0,0,1-.87-.9,39.19,39.19,0,0,1,2.07-12,.85.85,0,1,1,1.62.54Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M4.64,352.38a21.71,21.71,0,0,0,5.57,10,.79.79,0,0,1,0,1.1.77.77,0,0,1-1.08,0,23.45,23.45,0,0,1-3.79-4.89A21.74,21.74,0,0,1,3,352.77H3a.85.85,0,1,1,1.65-.4Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M19.67,369.26a68.47,68.47,0,0,0,11,4.53.51.51,0,0,1-.3,1,70.28,70.28,0,0,1-11.28-4.36.64.64,0,1,1,.58-1.14Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M42.22,376.8l11.82,2h0a.33.33,0,0,1-.1.66l-11.89-1.86a.39.39,0,0,1-.32-.44.39.39,0,0,1,.44-.33h0Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M66,380l12,.64h0a.36.36,0,1,1,0,.71h0l-12-.72a.32.32,0,0,1-.3-.34A.31.31,0,0,1,66,380Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M89.89,380.81l12-.16h0a.55.55,0,0,1,0,1.1h0l-12-.06a.44.44,0,0,1-.44-.44.45.45,0,0,1,.43-.44Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M113.82,380.2l12-.66h0a.79.79,0,0,1,.83.74.8.8,0,0,1-.74.83h0l-12,.44a.69.69,0,0,1-.7-.65.68.68,0,0,1,.64-.7Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M137.73,378.71l12-1h0a.91.91,0,0,1,1,.84.94.94,0,0,1-.85,1h0l-12,.86a.87.87,0,0,1-.13-1.73Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M161.63,376.6l11.92-1.26h0a1,1,0,1,1,.21,2h0l-12,1.17a1,1,0,0,1-.2-1.95Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M185.46,374l11.9-1.44h0a1,1,0,0,1,.26,2.07l-11.92,1.47a1.06,1.06,0,0,1-.26-2.1h0Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M209.26,371l11.88-1.64h0a1,1,0,0,1,1.13.86,1,1,0,0,1-.86,1.13L209.53,373a1,1,0,0,1-.28-2h0Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M233,367.67l11.86-1.76h0a.85.85,0,0,1,.26,1.67l-11.85,1.93a.93.93,0,0,1-.3-1.84h0Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M256.73,364.07l11.85-1.88a.63.63,0,0,1,.73.52.64.64,0,0,1-.51.72L257,365.57a.75.75,0,0,1-.88-.61.77.77,0,0,1,.61-.89Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M280.42,360.23l11.84-2a.3.3,0,1,1,.11.59l-11.77,2.37a.49.49,0,0,1-.58-.38.5.5,0,0,1,.39-.58Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M304.08,356.12l.14,0a.1.1,0,0,1,0,.2l-.14,0a.1.1,0,0,1-.12-.08.09.09,0,0,1,.07-.12Z"
          transform="translate(-1.62 -12.46)"
        />
      </g>
      <g>
        <path
          className="cls-2"
          d="M381.93,342.83A80.58,80.58,0,0,1,393.81,341a.32.32,0,0,1,.34.29.3.3,0,0,1-.29.34h0q-3,.15-6,.49c-2,.23-4,.5-5.92.89a.11.11,0,0,1-.12-.08A.12.12,0,0,1,381.93,342.83Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M405.86,340.88a62.87,62.87,0,0,1,11.94,1.94.62.62,0,0,1-.32,1.19h0a62.11,62.11,0,0,0-11.68-2.14.5.5,0,0,1-.45-.54A.51.51,0,0,1,405.86,340.88Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M429,347.45a35.87,35.87,0,0,1,9.28,7.91.78.78,0,0,1-.1,1.12.79.79,0,0,1-1.12-.1h0a34.6,34.6,0,0,0-8.83-7.65.74.74,0,0,1-.24-1A.75.75,0,0,1,429,347.45Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M444.44,365.93a50.4,50.4,0,0,1,2.9,11.83.89.89,0,1,1-1.77.23h0a49.23,49.23,0,0,0-2.71-11.45.85.85,0,1,1,1.58-.6Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M448.34,389.78a101.44,101.44,0,0,1-.11,12.08.77.77,0,0,1-1.54-.09c.15-4,.16-7.94-.06-11.9a.86.86,0,1,1,1.71-.1Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M446.67,413.84a88.58,88.58,0,0,1-3.09,11.66.44.44,0,0,1-.84-.27,89.33,89.33,0,0,0,2.73-11.61.61.61,0,1,1,1.2.2Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M439,436.63A90.63,90.63,0,0,1,432.86,447a.33.33,0,0,1-.44.09.32.32,0,0,1-.08-.44h0a77.59,77.59,0,0,0,6-10.33.35.35,0,1,1,.63.31Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M425.43,456.47a106.88,106.88,0,0,1-8.55,8.48.47.47,0,0,1-.63-.71h0a92.14,92.14,0,0,0,8.63-8.25.36.36,0,1,1,.54.48Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M407.43,472.42c-3.28,2.33-6.66,4.51-10.14,6.51a.76.76,0,1,1-.76-1.32h0c3.48-1.92,6.89-4,10.19-6.2a.61.61,0,0,1,.85.17A.61.61,0,0,1,407.43,472.42Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M386.6,484.52c-3.63,1.73-7.33,3.3-11.07,4.76a.93.93,0,0,1-.68-1.74h0q5.58-2.11,11-4.58a.86.86,0,0,1,.72,1.57Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M364.17,493.33q-5.73,1.86-11.55,3.43a1.06,1.06,0,0,1-.55-2h0q5.79-1.5,11.49-3.28a1,1,0,1,1,.6,1.89Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M340.91,499.56q-5.9,1.28-11.82,2.3a1,1,0,1,1-.36-2q5.89-1.05,11.73-2.33a1,1,0,1,1,.45,2Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M317.19,503.7q-6,.78-11.95,1.35a.89.89,0,0,1-.19-1.77q5.94-.67,11.87-1.55a1,1,0,1,1,.29,2Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M293.25,506l-12,.56a.64.64,0,0,1-.08-1.28h0l11.95-.85h0a.79.79,0,0,1,.11,1.57Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-2"
          d="M269.22,506.76c-4,0-8-.11-12-.27a.25.25,0,0,1-.23-.25.24.24,0,0,1,.24-.22c4,0,8-.09,12-.21a.48.48,0,0,1,0,.95Z"
          transform="translate(-1.62 -12.46)"
        />
      </g>
      <g id="Resources">
        <g>
          <path d="M342,331.54l-.16-.06C341.92,331.52,342,331.55,342,331.54Z" transform="translate(-1.62 -12.46)" />
          <g>
            <path
              className="cls-3"
              d="M345.12,330.91l-.11-.7-2-13.37a5.39,5.39,0,0,0-6.12-4.65L299.61,318a5.53,5.53,0,0,0-4.52,6.31l10.36,70.59a5.42,5.42,0,0,0,6.12,4.66l37.32-5.82a5.55,5.55,0,0,0,4.52-6.32l-2-14.26a25.91,25.91,0,0,1-2.43-1.06l2.64,16.64-44.11,6-11.16-72.37,44.37-7.1,2.19,14.26.09.42"
              transform="translate(-1.62 -12.46)"
            />
            <g>
              <path
                className="cls-4"
                d="M348.12,371.92h0a51.63,51.63,0,0,0,5.29,1.69.81.81,0,0,0,.38,0,.77.77,0,0,0,.36-.12,59.38,59.38,0,0,0,10.08-8c6.74-6.66,10.58-13.87,11.1-20.87.73-9.84-5.56-15.94-11.72-17.42-6.44-1.56-12.45,1.45-15.69,7.7a15.94,15.94,0,0,0-5.89-3.85.7.7,0,0,1-.17-.06,13,13,0,0,0-2-.55,13.17,13.17,0,0,0-9.15,1.75c-5.44,3.24-9.65,10.92-6,20.12,2.57,6.52,8.37,12.28,16.78,16.64,1.6.83,3.14,1.53,4.56,2.12"
                transform="translate(-1.62 -12.46)"
              />
              <path
                className="cls-5"
                d="M348.13,371.9c.93.35,1.86.67,2.81,1l1.42.43.71.19.36.09h.36a1.14,1.14,0,0,0,.54-.24l.52-.34,1-.69q1-.69,2-1.44c1.32-1,2.6-2,3.83-3.12a52.93,52.93,0,0,0,6.78-7.18,35.67,35.67,0,0,0,4.94-8.51,23.73,23.73,0,0,0,1.79-9.62,16.49,16.49,0,0,0-3-9.18,15.3,15.3,0,0,0-7.8-5.64,13.16,13.16,0,0,0-9.52.59,14.87,14.87,0,0,0-6.77,6.8l-.14.26-.2-.21a15.68,15.68,0,0,0-5.82-3.8H342a.84.84,0,0,1-.27-.08h0a12.73,12.73,0,0,0-7.7-.24,12.93,12.93,0,0,0-3.55,1.61,13.79,13.79,0,0,0-3,2.51,15.79,15.79,0,0,0-3.48,14.64c1.24,5.13,4.51,9.59,8.45,13.07a43.17,43.17,0,0,0,6.41,4.66,74.77,74.77,0,0,0,7.08,3.61l0,0a75,75,0,0,1-7.16-3.48,41.11,41.11,0,0,1-6.5-4.61c-4-3.48-7.37-7.95-8.68-13.19a17.79,17.79,0,0,1-.58-4,15.93,15.93,0,0,1,.4-4,16,16,0,0,1,3.72-7.07,14.47,14.47,0,0,1,3.09-2.59,13.1,13.1,0,0,1,3.68-1.65,13.3,13.3,0,0,1,8,.27h0s0,0,.05,0h.09a16.12,16.12,0,0,1,6,3.92l-.33,0a15.28,15.28,0,0,1,7-7,13.57,13.57,0,0,1,9.79-.57,15.61,15.61,0,0,1,7.94,5.8,16.68,16.68,0,0,1,3.05,9.35,23.75,23.75,0,0,1-1.85,9.71,35.39,35.39,0,0,1-5,8.54,52.63,52.63,0,0,1-6.83,7.17Q360,369.48,358,371c-.66.49-1.34,1-2,1.43l-1,.69-.53.33a1.14,1.14,0,0,1-.57.25h-.39l-.36-.09-.71-.2-1.42-.43c-.95-.3-1.88-.63-2.81-1Z"
                transform="translate(-1.62 -12.46)"
              />
            </g>
          </g>
        </g>
        <text className="cls-6" transform="translate(283.54 269.98)">
          Learn More
          <tspan x="-21.52" y="19.2">
            in our Resources
          </tspan>
        </text>
        <Link to="/articles/">
          <rect id="LinkRectangle" className="cls-7" x="263.7" y="251.76" width="134.24" height="138.8" />
        </Link>
      </g>
      <g id="GetEducated">
        <path
          className="cls-8"
          d="M96,114.37c1.93.75,4,0,5.92.68.69.24,1-1.24.29-1.48-1.94-.67-4,.07-5.91-.68-.69-.28-1,1.21-.3,1.48Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-8"
          d="M95.79,111c2.09.75,4.31,0,6.42.68.75.24,1.07-1.24.32-1.48-2.11-.67-4.34.07-6.42-.68-.75-.28-1.06,1.21-.32,1.48Z"
          transform="translate(-1.62 -12.46)"
        />
        <g>
          <g>
            <path
              d="M125.4,99.19A26.86,26.86,0,0,1,96.81,128c-16.15-1.13-26.53-12.92-25-28.36.87-8.58,4.28-16.28,8.12-24a243.74,243.74,0,0,1,17.1-29.55.84.84,0,0,1,.3-.27.53.53,0,0,0,0,.32,20.38,20.38,0,0,0,.3,2A227.4,227.4,0,0,0,83,73.21c-3.71,7.33-7.76,14.87-9.07,23-1.13,6.92-.92,14.9,3.58,20.8,5.47,7.14,15.71,10.81,24.82,9.14,8.27-1.52,16-6.41,19.34-14,3.95-8.9,2.86-19.63-1.64-28-3.89-7.26-11.21-15.71-15.7-22.63-3.12-4.8-5.77-8-6.74-13.28.28-.43.58-.87.88-1.3.49-.72-.46-1.4-1.12-1.07a.86.86,0,0,1,1.59.33c1,10.07,9.51,19.6,15.11,27.73C119.26,81.47,124.6,89.92,125.4,99.19Z"
              transform="translate(-1.62 -12.46)"
            />
            <path
              className="cls-9"
              d="M110.57,85.14c3.23,7.46-.93,12-5.3,17.91a.77.77,0,0,0-.57-.23h-.36c4.8-4,8.78-11,6.08-17.21-2.93-6.74-11.3-9.12-18.1-5.28-10.74,6.09-1.55,15,2,21.75a1.94,1.94,0,0,1,.07.74h-.29a.49.49,0,0,0-.24.05C92.51,98,86.58,93.25,86.78,88c.21-5.75,5.87-9,11.25-10S108.53,80.47,110.57,85.14Z"
              transform="translate(-1.62 -12.46)"
            />
            <path
              className="cls-10"
              d="M110.42,85.61c2.7,6.23-1.28,13.16-6.08,17.21h-3.4c1.11-2.21,2.57-4.14,3-6.64.08-.49.43-.82-.15-.82H103c-2.08,0-3.94,0-6,0l-.12-.16-.1.16h-.19c-.56,0-1.52.13-1.13.63,1.2,1.52,2.66,4.74,2.19,6.79H94.4a1.94,1.94,0,0,0-.07-.74c-3.56-6.8-12.75-15.66-2-21.75C99.12,76.49,107.49,78.87,110.42,85.61Z"
              transform="translate(-1.62 -12.46)"
            />
            <path
              className="cls-11"
              d="M105.27,103.05a.79.79,0,0,1-.57,1.35H94.11a.78.78,0,0,1-.24-1.53s0,0,0,.07c.19.7.47.44.51-.12h3.15a2.49,2.49,0,0,1-.08.32c-.29.86.62.45,1.06-.32H100c-.26.82.21,1.47.61.62.09-.21.19-.42.3-.62h3.4c-.17.16-.36.31-.55.46-.6.83.37,1.31,1,.49C104.92,103.53,105.1,103.3,105.27,103.05Z"
              transform="translate(-1.62 -12.46)"
            />
            <path
              className="cls-11"
              d="M105.27,103.05c-.17.25-.35.48-.52.72-.59.82-1.56.34-1-.49.19-.15.38-.3.55-.46h.36A.77.77,0,0,1,105.27,103.05Z"
              transform="translate(-1.62 -12.46)"
            />
            <path
              className="cls-8"
              d="M103.75,106.42c1,.24.59,1.76-.44,1.52-2.87-.68-5.92.07-8.77-.7a.8.8,0,0,1,.44-1.53C97.81,106.49,100.87,105.73,103.75,106.42Z"
              transform="translate(-1.62 -12.46)"
            />
            <path
              d="M103.75,95.36c.58,0,.23.33.15.82-.39,2.5-1.85,4.43-3,6.64H100a1.27,1.27,0,0,1,.08-.23,38.21,38.21,0,0,0,2.64-6.16h1c-.26-.34-.53-.68-.79-1v-.07Z"
              transform="translate(-1.62 -12.46)"
            />
            <path d="M103,95.43c.26.32.53.66.79,1h-1C102.83,96.1,102.89,95.76,103,95.43Z" transform="translate(-1.62 -12.46)" />
            <path
              d="M103,95.36v.07c-.06.33-.12.67-.2,1H97.6a9.78,9.78,0,0,0-.7-1C99,95.4,100.87,95.37,103,95.36Z"
              transform="translate(-1.62 -12.46)"
            />
            <path
              className="cls-12"
              d="M97.6,96.43h5.15a38.21,38.21,0,0,1-2.64,6.16,1.27,1.27,0,0,0-.08.23h-1.5a1.33,1.33,0,0,0,.15-.32C99.36,100.54,98.68,98.24,97.6,96.43Z"
              transform="translate(-1.62 -12.46)"
            />
            <path className="cls-11" d="M100.94,102.82c-.11.2-.21.41-.3.62-.4.85-.87.2-.61-.62Z" transform="translate(-1.62 -12.46)" />
            <path
              d="M97.6,96.43c1.08,1.81,1.76,4.11,1.08,6.07a1.33,1.33,0,0,1-.15.32h-1c.47-2-1-5.27-2.19-6.79-.39-.5.57-.63,1.13-.63h.19c-.21.33-.41.68-.62,1Z"
              transform="translate(-1.62 -12.46)"
            />
            <path
              d="M97.36,45.85c.66-.33,1.61.35,1.12,1.07-.3.43-.6.87-.88,1.3a20.38,20.38,0,0,1-.3-2,.53.53,0,0,1,0-.32Z"
              transform="translate(-1.62 -12.46)"
            />
            <path
              className="cls-11"
              d="M97.55,102.82h1c-.44.77-1.35,1.18-1.06.32A2.49,2.49,0,0,0,97.55,102.82Z"
              transform="translate(-1.62 -12.46)"
            />
            <path d="M97.6,96.43H96.06c.21-.35.41-.7.62-1h.22A9.78,9.78,0,0,1,97.6,96.43Z" transform="translate(-1.62 -12.46)" />
            <path d="M96.78,95.24l.12.16h-.22Z" transform="translate(-1.62 -12.46)" />
            <path
              className="cls-11"
              d="M94.11,102.82h.29c0,.56-.32.82-.51.12,0,0,0,0,0-.07A.49.49,0,0,1,94.11,102.82Z"
              transform="translate(-1.62 -12.46)"
            />
          </g>
          <g>
            <path
              className="cls-13"
              d="M105.27,103.05c4.37-5.87,8.53-10.45,5.3-17.91-2-4.67-7.09-8.26-12.54-7.23s-11,4.3-11.25,10c-.2,5.29,5.73,10,7.09,14.91"
              transform="translate(-1.62 -12.46)"
            />
            <path
              className="cls-13"
              d="M94.4,102.82a1.94,1.94,0,0,0-.07-.74c-3.56-6.8-12.75-15.66-2-21.75,6.8-3.84,15.17-1.46,18.1,5.28,2.7,6.23-1.28,13.16-6.08,17.21"
              transform="translate(-1.62 -12.46)"
            />
          </g>
        </g>
        <text className="cls-6" transform="translate(42.74 18.89)">
          Get Educated
        </text>
        <Link to="/education/free-courses/">
          <rect id="LinkRectangle-2" data-name="LinkRectangle" className="cls-7" x="37.77" width="118.53" height="121.07" />
        </Link>
      </g>
      <g id="ClinicalTrial">
        <text className="cls-6" transform="translate(30.29 203.97)">
          Connect with a
          <tspan x="12.92" y="19.2">
            Clinical Trial
          </tspan>
        </text>
        <g>
          <path
            d="M82.06,264.32a.78.78,0,0,1-.74-.71.22.22,0,0,1,0-.08.59.59,0,0,1,0-.13v0h0a12,12,0,0,0,.15-2.47v-.54a.75.75,0,0,1,.65-.74c.16,0,3.91-.51,4.92-.51.29,0,7,0,8.94-.16,1.29-.12,5.07-.17,5.23-.17a.68.68,0,0,1,.55.23.74.74,0,0,1,.21.56,20.28,20.28,0,0,0,.09,2.4c0,.55.08,1,.08,1.39a.76.76,0,0,1-.72.75s-1.61.07-3.16.07c-1,0-1.73,0-2.24-.08a37.51,37.51,0,0,0-3.87-.16H86.69a27.11,27.11,0,0,0-3.35.16l-1,.15A.68.68,0,0,1,82.06,264.32Zm10.1-1.87a38.21,38.21,0,0,1,4,.17c.45.05,1.15.07,2.08.07s1.74,0,2.34,0c0-.18,0-.36,0-.56,0-.58-.09-1.2-.1-1.79-1.2,0-3.45.07-4.35.15-1.92.17-8.34.17-9.07.17s-2.77.25-4.07.41a14.72,14.72,0,0,1,0,1.63l.18,0a27.36,27.36,0,0,1,3.57-.18h5.47Z"
            transform="translate(-1.62 -12.46)"
          />
          <path
            className="cls-14"
            d="M97.41,254.81h0a4.87,4.87,0,0,1-4.06-2.29,3.77,3.77,0,0,1-.2-3.74c.85-1.68,2.63-3.63,4.84-3.63a4,4,0,0,1,2.75,1.14,4.65,4.65,0,0,1,1.07,5.26A4.8,4.8,0,0,1,97.41,254.81Zm-.28-.85c1.56,0,3.27-.89,3.68-2s1-3.7-.08-4.72c-1.38-1.61-2.36-1.46-3-1.46-1.44,0-3.64,2.1-4.34,3.5-.5,1,.27,2.64.53,3.07a2.83,2.83,0,0,0,2.4,1.63"
            transform="translate(-1.62 -12.46)"
          />
          <path
            className="cls-15"
            d="M104.61,246.16a3,3,0,0,1-2.33-1.12,2.46,2.46,0,0,1-.45-2.7,3.21,3.21,0,0,1,2.84-1.76,2.61,2.61,0,0,1,2.2,1.16,2.77,2.77,0,0,1,.29,2.93A2.89,2.89,0,0,1,104.61,246.16Zm0-5.31a2.48,2.48,0,0,0-2.52,1.65,2.1,2.1,0,0,0,.53,2.49,5,5,0,0,0,2.36,1,2.51,2.51,0,0,0,2-1.46,4.14,4.14,0,0,0-.48-2.52C105.76,241.23,106.34,241.34,104.6,240.85Z"
            transform="translate(-1.62 -12.46)"
          />
          <path
            d="M98.4,270.12a.75.75,0,0,1-.75-.67c-.09-.95-.1-2-.1-3s0-1.71-.07-2.31A.75.75,0,0,1,99,264c.06.68.07,1.55.07,2.46s0,2,.09,2.88a.75.75,0,0,1-.67.82Z"
            transform="translate(-1.62 -12.46)"
          />
          <path
            d="M98.23,273.46a.79.79,0,0,1-.53-.22l-.17-.17A.75.75,0,1,1,98.59,272l.17.17a.75.75,0,0,1,0,1.06A.79.79,0,0,1,98.23,273.46Z"
            transform="translate(-1.62 -12.46)"
          />
          <path
            d="M72.42,326.25c-1.78,0-3.93-.22-5-1.8s-.33-3.22.43-4.77c.15-.3.29-.6.43-.91l.06-.1c.39-.59,1-1.57,1.87-2.78,2.65-3.9,7.08-10.43,8.58-13.54.43-.88,1.88-3,3.41-5.22,1.25-1.81,2.54-3.68,3-4.48v-.76c0-1.11,0-2.15,0-3.17,0-1.82.07-3.54,0-5.47-.09-1.69-.08-3.47-.07-5.2V277q0-1.57,0-3.18c0-1.19,0-2.39,0-3.57v-7a.75.75,0,0,1,1.5,0v7c0,1.18,0,2.38,0,3.58l0,3.17v1.1c0,1.71,0,3.47.06,5.11.11,2,.08,3.73,0,5.58,0,1,0,2,0,3.12l0,.95a.81.81,0,0,1-.08.34c-.38.79-1.73,2.75-3.16,4.82s-2.92,4.24-3.3,5c-1.55,3.21-6,9.8-8.69,13.73l-1.82,2.71c-.14.31-.29.61-.43.9-.75,1.51-1.14,2.4-.55,3.26.86,1.24,3.24,1.18,4.8,1.13h.17c1.33,0,7.71-.06,14.46-.09,7.88,0,16.8-.06,19.26-.12h1.14c2.07,0,5.17,0,6.39-1.21.71-.72,0-1.95-.8-3.26l-.17-.26c-1-1.56-2-3.11-3.07-4.61-.71-1-1.42-2.07-2.11-3.12a195.58,195.58,0,0,1-11.15-19,.76.76,0,0,1-.08-.33v-1c.13-2.14.14-3.77.15-5.5l0-1.46c0-.6,0-1.18-.08-1.79s-.09-1.19-.09-1.81c0-.32,0-.7.06-1.11a5.56,5.56,0,0,0-.13-2.47.75.75,0,0,1,.3-1,.73.73,0,0,1,1,.3,6.26,6.26,0,0,1,.32,3.31c0,.36-.06.7-.06,1,0,.58,0,1.13.08,1.69s.09,1.26.09,1.92l0,1.45c0,1.75,0,3.4-.15,5.53v.78a196.84,196.84,0,0,0,11,18.7c.69,1,1.39,2.06,2.1,3.09,1,1.51,2.11,3.08,3.1,4.66l.17.26c.82,1.31,2.21,3.49.59,5.12s-5,1.66-7.46,1.65h-1.1c-2.47.06-11.4.09-19.28.12-6.74,0-13.11.05-14.43.09h-.17Z"
            transform="translate(-1.62 -12.46)"
          />
          <path
            d="M89.37,273a5.59,5.59,0,0,1-1.32-.12,8.52,8.52,0,0,0-1.69-.23.75.75,0,0,1-.71-.78.77.77,0,0,1,.78-.72,10.89,10.89,0,0,1,2,.27,6.13,6.13,0,0,0,1.47.07h.51a.75.75,0,1,1,0,1.5h-1Z"
            transform="translate(-1.62 -12.46)"
          />
          <path d="M90.4,279.12h-4a.75.75,0,1,1,0-1.5h4a.75.75,0,0,1,0,1.5Z" transform="translate(-1.62 -12.46)" />
          <path
            d="M86.9,285.12a.74.74,0,0,1-.75-.74.75.75,0,0,1,.74-.76c.62,0,1.75-.07,2.65-.12l1-.06a1.07,1.07,0,0,1,.69.06.91.91,0,0,1,.26.13.78.78,0,0,1,.21,1,.77.77,0,0,1-1,.28h0l-1.16.06c-1,.06-2.08.13-2.73.13Z"
            transform="translate(-1.62 -12.46)"
          />
          <path
            d="M105.67,305.68c-1.59,0-5.16-.12-6.85-.11-1.38,0-2.81.06-4.19.11s-2.94.12-4.43.12c-.53,0-1,0-1.57,0l-1.4,0c-.89,0-1.73-.08-2.61-.08H80a6.54,6.54,0,0,1-2.32-.17c-.29-.12-.28-.32,0-.44a1.65,1.65,0,0,1,1,0,11,11,0,0,0,1.15,0h4.66c1,0,1.93.05,2.84.09l1.36.05c1.87.06,3.84,0,5.74-.09,1.41-.05,2.88-.11,4.32-.11,1.73,0,5.35.06,7,.11"
            transform="translate(-1.62 -12.46)"
          />
        </g>
        <path
          className="cls-16"
          d="M112.5,325l-22.89.33-18.43.14a3.15,3.15,0,0,1-3-3.61,1.68,1.68,0,0,1,.31-.71l1.14-1.67,8.51-13a7.6,7.6,0,0,1,1.06-1.65l24.08-1.14c.67,0,1.9,2.19,2.27,2.75l9.25,14.11A2.91,2.91,0,0,1,112.5,325Z"
          transform="translate(-1.62 -12.46)"
        />
        <Link to="/resources/how-to-join-psychedelic-clinical-trial/">
          <rect id="LinkRectangle-3" data-name="LinkRectangle" className="cls-7" x="30.68" y="186.41" width="123.6" height="131.2" />
        </Link>
      </g>
      <g id="FindAProvider">
        <ellipse className="cls-17" cx="283.57" cy="162.14" rx="13.4" ry="14.21" />
        <path
          d="M305.46,132.1c-7.88-5.11-17.44-2.93-26-.73-9.44,2.42-18.66,6.43-25.56,13.49-12.22,12.5-13.72,34.59-7,50.22,7.16,16.72,24.93,22.62,42,20.68,8.9-1,18-3.6,25-9.4a49,49,0,0,0,15.18-23.61C332,173,332,162.2,328,152.75c-3.48-8.2-10.84-16.2-20.48-14.56-2,.34.6.78,2.54.8,18.94.16,22.87,36.09,16.76,46.29-4.91,16.82-18.32,25.92-35.4,29.16-15.43,2.93-33.44-.56-41.57-15.3-7.33-13.31-8.09-36.21.76-48.82,5.67-8.08,15-13,24.29-16s21.41-6.66,30.41-1.9a.16.16,0,0,0,.16-.28Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          d="M248.91,172.92c11.12.48,19.15-7.71,29.19-11a23.91,23.91,0,0,1,19.7,1.62c4.1,2.19,8.73,7.06,13.58,6.32.72-.11.78-1.2.19-1.52-2.77-1.52-6-2.14-8.89-3.48-2.55-1.18-5-2.54-7.6-3.64a19,19,0,0,0-12.86-1.32C270.75,162.32,261,172,248.91,172.61a.16.16,0,0,0,0,.31Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          d="M249.6,175.11c8.17-.1,14.67,7.95,21.4,11.73,5.53,3.11,12,5.17,18.35,4.36,11.8-1.49,23.22-10.24,29.68-19.88.8-1.19-1.09-2.69-2-1.55-8.32,10.32-21.49,21.32-35.74,18.68-6.61-1.23-12.46-4.84-18-8.5-4.28-2.83-8.37-5.87-13.71-4.93a0,0,0,0,0,0,.09Z"
          transform="translate(-1.62 -12.46)"
        />
        <path d="M274.36,163.38a.08.08,0,1,0,0-.16.08.08,0,0,0,0,.16Z" transform="translate(-1.62 -12.46)" />
        <path
          className="cls-18"
          d="M286.34,159.89c-8.68.29-17,6.28-16.88,15.64.08,9.9,10.92,15.95,20.08,14.11C297.87,188,303.77,176.72,300,169c-4.34-8.81-15.71-9.06-22.11-2.59-1.16,1.16.4,3.39,1.82,2.35,7-7.12,14.93-6.43,18.35.56,1.79,3.64.89,10-1.16,13.18-2.73,4.27-9,6.82-13.87,5.88-6.83-1.31-13.35-7.9-11.88-15.48,1.31-6.8,7.85-11.66,15.33-12a.5.5,0,0,0-.13-1Z"
          transform="translate(-1.62 -12.46)"
        />
        <text className="cls-6" transform="translate(224.71 106.02)">
          Find a Provider
        </text>
        <g>
          <ellipse className="cls-19" cx="282.37" cy="163.5" rx="4.64" ry="4.56" />
          <path
            className="cls-20"
            d="M288.69,176a5.35,5.35,0,0,1-1.21,3.46,4.28,4.28,0,0,1-3.48,1.52,5.13,5.13,0,0,1-3.39-1.63,5.38,5.38,0,0,1-1.53-3.35,4.61,4.61,0,0,1,1.32-3.58,5,5,0,0,1,3.6-1.52,4.61,4.61,0,0,1,3.49,1.62A5.34,5.34,0,0,1,288.69,176Zm-.1,0a3.8,3.8,0,0,0-1.56-3,5,5,0,0,0-3-1,4.38,4.38,0,0,0-4.37,4,3.81,3.81,0,0,0,1.21,3.12,4.23,4.23,0,0,0,3.16,1,5.43,5.43,0,0,0,3-1.13A3.8,3.8,0,0,0,288.59,176Z"
            transform="translate(-1.62 -12.46)"
          />
        </g>
        <Link to="/provider-network/">
          <rect id="LinkRectangle-4" data-name="LinkRectangle" className="cls-7" x="222.16" y="85.61" width="128.16" height="124.11" />
        </Link>
      </g>
      <g id="Community">
        <path
          className="cls-21"
          d="M255.53,539.69c-1.68-28.44.45-50-35.84-46-6.11.23-13.35-8.67-18.39-2.61-10.23,5.76,1.74,20.46,3.86,27.74,1.19,5.69.6,25.71,1.63,35.65C210.62,565.47,261.87,556.28,255.53,539.69Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-22"
          d="M184.09,491.3c.5-.37,0-.22.24.35,1.84,4.53,1.29,15.08,2.58,18.67,4.56,12.61-5,27.12-18.29,28.2-5,.41-8.79-1.24-11.13-5.83-.63-1.25-1.39-2.44-2.1-3.65-.09-.15,0-.16-.13-.49-2.78-9-3-12-.69-23a1,1,0,0,1,.64-.7c1.92-.68,6.51-4.42,10.61-7.6a1,1,0,0,1,1.23,1.47c-4,3.68-8.61,7.8-9.13,9.71-2.15,7.89,0,15.24,4.07,22.17a5.63,5.63,0,0,0,5.73,3.09c9.82-.65,17.34-11,15-20.5-1.25-5.07-6.58-9.13-10.35-12.9-.43-.42-3.75-7.1-3.27-7.46C171.26,491.17,181.91,492.91,184.09,491.3Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          d="M232.63,493.75c.3.39,4,1.35,4.5,1.52,2.33.48,8.82,2.61,11,4,5.78,5.72,7.83,33.5,5.39,49.36-.11.72-.28,1.54.59,1.54s1.46-.48,1.46-1.21c.61-8.08.21-47.33-7.54-51.64-2.63-1.45-11.22-3.63-13.7-4.23a15.92,15.92,0,0,1,.88-3.52c.72-1.09,6-9,6-15.14,0-6.78-.44-13.81-5.1-16.71-2.48-1.46-5.68-1.7-9.76-.73-7.72,1.94-12.24,8.24-12.24,17.44,0,6.3,2.48,12.24,6.27,15.51a26.07,26.07,0,0,1,.34,3.5,14.13,14.13,0,0,1-3.41-.45c-2-.75-5.7-1.94-7.6-2.89-5.68-2.67-14.24-7.51-22.4-8.35,2-3.39,4.25-7.78,4.25-12.38,0-9,0-15.06-11.54-16.63a10,10,0,0,0-7.82,2.13c-4.91,3.67-6.44,9.89-6.46,16,0,5.57,4.2,10.28,6.68,13.67-7.28,1.82-16.07,4.72-22.81,13.68-3.93,5.21-4.81,9.45-2,10.9,1.46.85,3.64.49,6-.84-4.66,19.62,4.08,47.72,4.67,49.17a1.43,1.43,0,0,0,1.5.85h.44c.73-.12-.81-2.46-1.12-3.06-.15-.37-13.71-39.68-.3-56.28,3.08-3.81,10.2-6.76,15.09-7l.88-.13.29-.6c.15-.24.29-.73.29-4.48v-.37l-.29-.36c-.15-.12-8.16-8.36-8.16-16.47,0-5.57,2.48-10.9,6.56-13.81a9.64,9.64,0,0,1,6.7-1.94c8.59,1.09,10,5.94,10,15.75,0,7.26-7,15.74-7.14,15.86l-.29.37v.48c.58,4.61,1.31,5.21,1.6,5.45l.15.12.29.13c15.59,6.29,20.47,20.92,20.76,48.43.13.7-.94,3.79-.22,3.78h0a1.34,1.34,0,0,0,1.46-1.21c-.15-11.51-.73-21.2-2.62-29.19-.59-5.57-5.4-13.94-7.44-16.61-1-1.14,7.83-7.86,6.5-8.56-7.47,9.86-13.73,4.3-17.8,2.65a26,26,0,0,1-.91-4.71c.3-.36,0-2.56,2.43-3.41,8,.6,15.32,5.44,21.44,8.23,2.19,1,4.23,1.94,6.12,2.66,1.16.37,6.85,1.22,7.87,0,1.31-1.45,0-4.14-.1-4.42l-.8-.8h0c-3.64-2.78-6.53-8.77-6.53-14.59,0-8,5.58-14.94,12-16.52,3.21-.84,8.12.92,9.72,2,3.64,2.3,3.77,10.54,3.77,16.47s-7.92,13.5-7.92,13.62m-58.64-.06c-5.68.85-12.89,3.89-16.1,8a28.86,28.86,0,0,0-3.93,7c-3.06,2.78-5.1,3.27-5.53,3-.59-.24-2.83-2.84,1-7.81a40.31,40.31,0,0,1,23-14.7c.26.36,1.57,1.5,1.89,1.81"
          transform="translate(-1.62 -12.46)"
        />
        <text className="cls-6" transform="translate(99.42 423.56)">
          Join a Community Group{" "}
        </text>
        <path d="M206.08,530.47" transform="translate(-1.62 -12.46)" />
        <path d="M203.6,516.45" transform="translate(-1.62 -12.46)" />
        <path
          className="cls-23"
          d="M188.93,559c-2.26-1.89-2.52-4-.84-6.91a27.65,27.65,0,0,1,3.7-5.3c4.48-4.81,9.15-9.45,13.69-14.21l-.81-6.37c-5,5.27-13.3,13.88-18.12,19.28a22.44,22.44,0,0,0-3.74,6.43,8.69,8.69,0,0,0-.06,7.08Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-24"
          d="M179.06,559a9.45,9.45,0,0,1,.1-5.94,39.08,39.08,0,0,1,8.37-15.18c4.17-4.57,7.91-9.45,10.16-15.31a24,24,0,0,0-2.38-22.68c-.63-1-1.31-1.92-2-2.87l-5-3.62c8.94,8.77,6.71,20,1.87,29.65-1.75,3.49-4,6.73-5.87,10.16-3,5.38-6.31,10.62-8.63,16.27a15.24,15.24,0,0,0-.91,9.52Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          d="M207.23,551.25c-1.2.81-2.69,1.43-4.5,2.43.54-3.72,1.81-9,3.62-11.12l-.42-4.82c-2,2.25-2,3-3.63,5.46a33.78,33.78,0,0,0-4.37,9.35c-.91,3.5,1.25,5.59,4.89,5.43a12.42,12.42,0,0,0,4.34-1C207.21,555.09,207.23,553.17,207.23,551.25Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-25"
          d="M157.57,546.5c.59.88,5.05,12.07,5.56,13l8.6-.1c-1.07-2.14-9.3-14.43-10.81-16.47-1.14-1.54-3.81-1.95-5.78-2.89v5C156,545.49,157.09,545.78,157.57,546.5Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-26"
          d="M158.68,515.12c.95-2.52.56-5.24,1.93-7.51,3.28-5.45,9.87-6.33,14.84-2.06,4.22,3.63,7.22,8.13,5.62,14s-6.35,9.11-12,10.94a3.87,3.87,0,0,1-2.76-.51C161.43,527.07,159.18,521.11,158.68,515.12Zm4.46.09a12.35,12.35,0,0,0,4.5,9.54,2.11,2.11,0,0,0,1.76.37c7.31-2.16,9.22-9.34,3.94-14.8-1.48-1.52-3.12-2.94-5.44-2.37-2.54.62-3.72,2.66-4.42,5A13.23,13.23,0,0,0,163.14,515.21Z"
          transform="translate(-1.62 -12.46)"
        />
        <path
          className="cls-27"
          d="M172.53,513.28a5.56,5.56,0,0,1-.13,4.84,12.5,12.5,0,0,1-2.7,2.9c-1,.69-3.45-2.86-3.46-5,0-2,1.88-4.17,2.94-2.49C170.13,515,171.73,512.14,172.53,513.28Z"
          transform="translate(-1.62 -12.46)"
        />
        <path className="cls-28" d="M208.23,507.84c0-3,1.42-5.24,3.43-5.28s6.34,3,6.39,4.54" transform="translate(-1.62 -12.46)" />
        <path d="M228.1,508.23c2.55.14,3.82,1.18,3.7,3-.14,2.09-2.29,5-3.59,4.82" transform="translate(-1.62 -12.46)" />
        <path
          className="cls-29"
          d="M214.84,514.42c-.43-2.38.73-6.09,3.25-3.62,1.2,1.17,4.75-2,5.1,0s-2,9-3.48,9.26C218,520.33,215.37,517.32,214.84,514.42Z"
          transform="translate(-1.62 -12.46)"
        />
        <g>
          <path d="M219.67,525.79c2.74-1.34,5.33-1,6.24.77s.05,7-1.29,7.73" transform="translate(-1.62 -12.46)" />
          <path d="M215.1,534.8c1,2.36.61,4-1.1,4.65-1.94.79-5.48.12-5.91-1.11" transform="translate(-1.62 -12.46)" />
          <path
            d="M227.16,543.23a5.61,5.61,0,0,1,.58,1.7,2.37,2.37,0,0,1-.37,1.78,5.56,5.56,0,0,1-3.15,1.81,5.07,5.07,0,0,1-3.57-.36,3,3,0,0,1-1.23-1.32,5.46,5.46,0,0,1-.39-1.77,12.13,12.13,0,0,1,.34-3.6,7,7,0,0,1,.67-1.72,1.93,1.93,0,0,1,.68-.75,1.87,1.87,0,0,1,1-.23,5.5,5.5,0,0,1,3.29,1.6A10,10,0,0,1,227.16,543.23Zm0,0a7.72,7.72,0,0,0-2.32-2.63,6.17,6.17,0,0,0-3.08-1.33,1.34,1.34,0,0,0-.73.16,1.77,1.77,0,0,0-.5.57,6.41,6.41,0,0,0-.65,1.57,12.67,12.67,0,0,0-.52,3.47,4.48,4.48,0,0,0,.27,1.71,2.44,2.44,0,0,0,1.15,1.24,4.57,4.57,0,0,0,3.39.11,6.87,6.87,0,0,0,3-1.6,2.12,2.12,0,0,0,.49-1.58A4.91,4.91,0,0,0,227.11,543.25Z"
            transform="translate(-1.62 -12.46)"
          />
          <path d="M204.42,519.38c2.74-1.34,5.33-1,6.24.78s.05,7-1.29,7.72" transform="translate(-1.62 -12.46)" />
        </g>
        <g>
          <path d="M241.38,507.61c2.74-1.34,5.33-1,6.24.78s0,7-1.29,7.73" transform="translate(-1.62 -12.46)" />
          <path d="M236.81,516.63c1,2.35.61,4-1.1,4.65-1.94.78-5.48.12-5.91-1.12" transform="translate(-1.62 -12.46)" />
          <path
            d="M248.88,525.05a7,7,0,0,1,.61,1.7,2.45,2.45,0,0,1-.35,1.83,3.81,3.81,0,0,1-1.45,1.23,7.48,7.48,0,0,1-1.73.64,5.18,5.18,0,0,1-3.61-.43,3,3,0,0,1-1.26-1.34,5.55,5.55,0,0,1-.41-1.79,10.85,10.85,0,0,1,.29-3.63,7.31,7.31,0,0,1,.67-1.76,2.06,2.06,0,0,1,.72-.79,1.92,1.92,0,0,1,1.07-.25,5.36,5.36,0,0,1,3.33,1.67A10.91,10.91,0,0,1,248.88,525.05Zm-.07,0a7.06,7.06,0,0,0-2.36-2.58,6.29,6.29,0,0,0-3-1.25,1.09,1.09,0,0,0-1.1.65,6.28,6.28,0,0,0-.66,1.54,14.21,14.21,0,0,0-.56,3.43,4.23,4.23,0,0,0,.24,1.7,2.46,2.46,0,0,0,1.13,1.23,4.48,4.48,0,0,0,3.34,0,7.48,7.48,0,0,0,3-1.54,2,2,0,0,0,.53-1.53A4.21,4.21,0,0,0,248.81,525.09Z"
            transform="translate(-1.62 -12.46)"
          />
        </g>
        <g>
          <path d="M233.27,539.24c1.09-2.84,3.2-4.38,5.09-3.69s4.82,5.11,4.32,6.54" transform="translate(-1.62 -12.46)" />
          <path d="M236.07,549c2.33,1,3.14,2.48,2.36,4.16-.88,1.89-3.92,3.81-5.08,3.2" transform="translate(-1.62 -12.46)" />
          <path
            d="M250.63,546.92a5.51,5.51,0,0,1,1.56.85,2.3,2.3,0,0,1,.85,1.54,6.21,6.21,0,0,1-1,3.41,4.92,4.92,0,0,1-2.76,2.34,2.86,2.86,0,0,1-1.89-.12,5,5,0,0,1-1.51-1.08,12.43,12.43,0,0,1-2.11-3,7,7,0,0,1-.62-1.73,2,2,0,0,1,0-1,1.66,1.66,0,0,1,.55-.77,5.94,5.94,0,0,1,3.41-1.05A8.77,8.77,0,0,1,250.63,546.92Zm0,0a8.74,8.74,0,0,0-3.51-.45,5.77,5.77,0,0,0-3.25,1.16,1.39,1.39,0,0,0-.43.68,1.57,1.57,0,0,0,0,.8,7.11,7.11,0,0,0,.66,1.6,11.87,11.87,0,0,0,2.08,2.79,4.63,4.63,0,0,0,1.34,1,2.47,2.47,0,0,0,1.61.13,4.68,4.68,0,0,0,2.65-2.06,6,6,0,0,0,1.15-3.27,2.22,2.22,0,0,0-.8-1.52A5.35,5.35,0,0,0,250.63,546.92Z"
            transform="translate(-1.62 -12.46)"
          />
        </g>
        <path
          d="M204,493.16a14.3,14.3,0,0,1,1.44-.48,3,3,0,0,1,1.55-.07,1.81,1.81,0,0,1,1.15,1.14,3.35,3.35,0,0,1,.2,1.57,3.49,3.49,0,0,1-1.77,2.48,7.46,7.46,0,0,1-2.92.81,13,13,0,0,1-3.05,0,4.94,4.94,0,0,1-1.53-.42,1,1,0,0,1-.38-.36.88.88,0,0,1-.07-.52,2.1,2.1,0,0,1,.34-.79A11,11,0,0,1,204,493.16Zm0,0a10,10,0,0,0-2.56,1.53,10.32,10.32,0,0,0-2.07,2.05,1.52,1.52,0,0,0-.25.58c0,.2,0,.23.19.36a4.26,4.26,0,0,0,1.35.4,16.08,16.08,0,0,0,2.95.2,5.37,5.37,0,0,0,2.85-.68,3,3,0,0,0,1.44-2.37,3.1,3.1,0,0,0-.2-1.38,1.57,1.57,0,0,0-.84-1A4.22,4.22,0,0,0,204,493.21Z"
          transform="translate(-1.62 -12.46)"
        />
        <path d="M224,494.71c2.8-1.2,5.37-.75,6.19,1.08s-.29,7-1.65,7.66" transform="translate(-1.62 -12.46)" />
        <path d="M209.78,548c2.79-1.21,5.37-.76,6.19,1.07s-.29,7-1.66,7.66" transform="translate(-1.62 -12.46)" />
        <Link to="/community-directory/">
          <rect id="LinkRectangle-5" data-name="LinkRectangle" className="cls-7" x="97.54" y="403.73" width="205.66" height="146.4" />
        </Link>
      </g>
    </svg>
  );
};
